import { Space, Table } from 'antd';
import { DeleteActionSvg, EditActionSvg } from 'utils/svgs';
import styles from './index.module.scss';
import { useContext } from 'react';
import { PermissionContext } from 'components/Global/AuthLayout';

const { Column } = Table;

type Props = {
	jobGradeData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	setEditData: any;
	openDrawerHandler: any;
	setDrawerInfoHandler: any;
	showModal: any;
	isLoading: boolean;
};

const JobGradeTable = (props: Props) => {
	const {
		jobGradeData,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		openDrawerHandler,
		setDrawerInfoHandler,
		setEditData,
		showModal,
		isLoading,
	} = props;

	const permissions = useContext(PermissionContext);


	// Edit user data handler
	const editDataHandler = (selectedObj: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Job Title');
		setEditData(selectedObj);
	};

	// Delete user data handler
	const deleteDataHandler = (userObject: any) => {
		setEditData(userObject);
		showModal();
	};
	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={jobGradeData}
				scroll={{ y: 'calc(100vh - 360px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					// onShowSizeChange: pageSizeHandler,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				loading={isLoading}
			>
				<Column
					title="Job Title"
					dataIndex="jobGrade"
					key="jobGrade"
					sorter={true}
					className="bg-white"
				/>
				<Column
					title="Position"
					dataIndex="position"
					key="position"
					className="bg-white"
					sorter={true}
				/>
				<Column
					title="Lower Rate"
					dataIndex="lowerRate"
					key="lowerRate"
					className="bg-white"
					sorter={true}
				/>
				<Column
					title="Upper Rate"
					dataIndex="upperRate"
					key="upperRate"
					className="bg-white"
					sorter={true}
				/>
				<Column
					title="Sal Rate"
					dataIndex="salRate"
					key="salRate"
					className="bg-white"
					sorter={true}
				/>
				{(permissions.allowedPermissions.includes('Edit_Job_Grade') ||
					permissions.allowedPermissions.includes(
						'Delete_Job_Grade'
					)) && (
					<Column
						title="Action"
						key="action"
						className="bg-white"
						render={(_: any, data: any) => (
							<Space size={20}>
								{permissions.allowedPermissions.includes(
									'Edit_Job_Grade'
								) ? (
									<div
										className="cursor-pointer  flex align-center justify-center"
										onClick={() => editDataHandler(data)}
									>
										<EditActionSvg />
									</div>
								) : (
									<div className="cursor-not-allowed  flex align-center justify-center">
										<EditActionSvg color="#928F8F" />
									</div>
								)}
								{permissions.allowedPermissions.includes(
									'Delete_Job_Grade'
								) ? (
									<div
										className="cursor-pointer flex align-center justify-center"
										onClick={() => deleteDataHandler(data)}
									>
										<DeleteActionSvg />
									</div>
								) : (
									<div className="cursor-not-allowed flex align-center justify-center">
										<DeleteActionSvg color="#928F8F" />
									</div>
								)}
							</Space>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default JobGradeTable;
